import React from "react";
import { LossAnalysisAdminPageView } from "./loss-analysis-admin-page-view";
export const LossAnalysisAdminPageController = (props) => {
  return (
    <>
      <LossAnalysisAdminPageView {...props} />    
    </>
  );
};